import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  title: {
    textDecoration: "underline",
    fontFamily: 'Roboto-Bold',
  },
  text: {
    fontStyle: "italic"
  }
}));
